import React from 'react';
import { useTranslation } from 'react-i18next';
import useNotifications from './useNotifications';

const useNotificationsTable = (counter) => {
    const { t } = useTranslation();

    const { data, loading, error } = useNotifications(counter);
    console.log("Notifications data:", data);
    const columns = [
        { Header: t("notifications.table.columns.name"), accessor: "name" },
        { Header: t("notifications.table.columns.state"), accessor: "state" },
        { Header: t("notifications.table.columns.activeSince"), accessor: "last_evaluation" },
        { Header: t("notifications.table.columns.value"), accessor: "value" },
    ];

    const unknown = t("notifications.table.unknown");

    const rows = data.map((item) => {
        const alert = item.rules[0].alerts?.[0];
        console.log("Processing item:", alert);

        if (!alert) {
                  console.log("Processing item without alert:", item);
            console.log("[NotificationsTable] No active alert for rule:", item.rules[0].name, "| group:", item.name, "| raw alerts:", item.rules[0].alerts);
        } else {
            if (!alert.activeAt) {
                console.log("[NotificationsTable] Missing activeAt for rule:", item.rules[0].name, "| raw alert:", alert);
            }
            if (isNaN(parseFloat(alert.value))) {
                console.log("[NotificationsTable] Unparseable value for rule:", item.rules[0].name, "| raw value:", alert.value, "| raw alert:", alert);
            }
        }

        return {
            type: item.name || unknown,
            name: item.rules[0].name || unknown,
            state: item.rules[0].state || unknown,
            last_evaluation: alert ? alert.activeAt : "-",
            value: alert != null ? parseFloat(alert.value).toFixed(3) : "-",
            file: item.file || "",
        };
    });

    // Return the table-ready data
    return {
        tableData: { columns, rows },
        loading,
        error,
    };
};

export default useNotificationsTable;